import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import Routing from "../../../../Routing.ts";
import {Link} from "react-router-dom";

export default function SbbuArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className={'article'}>
                    <div className="paragraph">
                        <h2>Fibernet og internet via kabel-tv-stikket</h2>
                        <p>
                            Er du helt ny Hiper-kunde, kan vi opsige abonnementet hos din nuværende internetudbyder.
                            Det kræver, at du udfylder en fuldmagt, der giver os lov til at opsige abonnementet på vegne af dig.
                        </p>
                        <p>
                            Du kan udfylde fuldmagten, når du bestiller online eller i Mit Hiper, efter du har bestilt.
                            Hvis du ikke udfylder den ved bestilling, får du en mail, der fortæller, hvordan du udfylder den i Mit Hiper.
                        </p>

                        <h3>Fuldmagten skal indeholde fire oplysninger</h3>
                        <ul className={'list list--bullet'}>
                            <li>
                                <p>Dit navn (evt. virksomhedsnavn)</p>
                            </li>
                            <li>
                                <p>Din adresse</p>
                            </li>
                            <li>
                                <p>Dit kundenummer hos nuværende udbyder*</p>
                            </li>
                            <li>
                                <p>Dato hvor du ønsker at opsige hos din nuværende udbyder</p>
                            </li>
                        </ul>
                        <p>
                            *Hvis din nuværende udbyder er Telenor, starter kundenummeret med &ldquo;dsl&rdquo;.
                        </p>

                        <h3>Oplysningerne til fuldmagten står på din seneste faktura</h3>
                        <p>
                            Alle oplysningerne, som du skal bruge til at udfylde fuldmagten, står på fakturaerne fra din nuværende udbyder.
                            Dobbelttjek derfor oplysningerne på fakturaerne, så du er sikker på, at de er korrekte i fuldmagten.
                            Ellers afviser udbyderen nemlig fuldmagten.
                        </p>

                        <h3>Du har 30 dage til at udfylde fuldmagten </h3>
                        <p>
                            Du kan udfylde fuldmagten op til 30 dage efter datoen, hvor dit internet er klar hos os.
                            Vi kan dog ikke garantere, at din tidligere udbyder vil opsige dit abonnement med tilbagevirkende kraft, og du kan derfor komme til at betale for begge abonnementer i en periode.
                        </p>

                        <h3>Når du har udfyldt fuldmagten, sender vi den automatisk til din nuværende udbyder</h3>
                        <p>
                            Udbyderen har tre hverdage til at behandle fuldmagten.
                        </p>
                        <p>
                            Du får en mail, når udbyderen har behandlet fuldmagten.
                            Udbyderen kan enten acceptere eller afvise opsigelsen.
                        </p>
                        <p className={'pb-half'}><strong>Hvis udbyderen accepterer opsigelsen:</strong></p>
                        <ul className={'list list--bullet'}>
                            <li>
                                <p>Du får en mail om, at fuldmagten er godkendt, og opsigelsen er startet.</p>
                            </li>
                            <li>
                                <p>
                                    Det er en god idé at tjekke, at opsigelsesdatoen hos udbyderen og datoen, hvor dit internet er klar hos os, stemmer overens, så du ikke står uden internet.
                                    Hvis ikke, sørger vi også for at sende en mail til dig.
                                </p>
                            </li>
                        </ul>
                        <p className={'pb-half'}><strong>Hvis udbyderen afviser opsigelsen:</strong></p>
                        <ul className={'list list--bullet'}>
                            <li>
                                <p>
                                    Du får en mail, der forklarer årsagen til, at udbyderen har afvist opsigelsen.
                                    Det kan eksempelvis være, hvis du har skrevet forkert kundenummer eller ikke angivet en adresse i fuldmagten.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Du skal udfylde en ny fuldmagt i Mit Hiper med den korrekte information.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        <p>
                                            Alternativt kan du også sende en faktura fra din tidligere udbyder til os &ndash; så sender vi en ny fuldmagt til dem.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <h3>Vil du ændre datoen for opsigelsen af din nuværende udbyder?</h3>
                        <p>
                            Så skal du <Link to={Routing.Contact.Index}>kontakte os</Link>.
                            Vi kan dog ikke rykke datoen til en tidligere dato &ndash; kun en senere dato.
                        </p>
                    </div>
                </div>

                <div className={'article'}>
                    <div className="paragraph">
                        <h2>5G-internet</h2>
                        <p>
                            Når du bestiller 5G-internet hos os og i forvejen har internet hos en anden udbyder, skal du selv opsige abonnementet hos udbyderen.
                            Vi kan desværre ikke gøre det for dig.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "leveringstid",
                        "name": "Hvor hurtigt kan jeg få leveret internet?"
                    },
                    {
                        "category": "bestilling",
                        "article": "fiber-installation",
                        "name": "Om fiberinstallation"
                    },
                    {
                        "category": "bestilling",
                        "article": "kan-jeg-faa-1000-mbit",
                        "name": "Kan jeg få 1.000 Mbit?"
                    },
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    }
                ]}
            />
        </>
    )
}